export default __webpack_public_path__ + "static/media/john.9ca48038.webp";